import {
  Component,
  EventEmitter,
  Input,
  Output,
  SimpleChanges, OnInit
} from "@angular/core";

import { NgxSpinnerService } from "ngx-spinner";

import {
  DomSanitizer,
  SafeResourceUrl,
  SafeUrl,
} from "@angular/platform-browser";

import { FileData } from "../../../models/util/claims";

type PreviewKind = "image" | "pdf" | "xml" | "other";

interface PreviewItem {
  fileName: string; // siempre
  type: PreviewKind;
  url?: SafeUrl | SafeResourceUrl; // img: SafeUrl, pdf: SafeResourceUrl
  objUrl?: string; // para abrir/descargar
  text?: string; // snippet XML
  file?: File; // opcional (si viene del dropzone)
}

@Component({
  selector: "app-modal-upload-images",
  templateUrl: "./modal-upload-images.component.html",
  styleUrls: ["./modal-upload-images.component.scss"],
})
export class ModalUploadImagesComponent {
  uploads: FileData[] = [];
  @Input() multipleUpload: boolean = true;
  @Input() textTypeFiles: string = "XML-PDF-JPG";
  @Input() typeDocumentValid: string =
    "image/jpeg,image/jpg,image/png,application/pdf,text/xml,application/xml";
  @Input() modalClaims: boolean = false;
  // NUEVO: modo ver + archivos existentes (base64)

  @Input() previewOnly: boolean = false;

  @Input() existingUploads: FileData[] | null = null;

  @Output() close = new EventEmitter<any>();

  @Output() sendFiles = new EventEmitter<FileData[]>();

  files: File[] = [];

  previews: PreviewItem[] = [];

  public statusUploadFile: "error" | "success" | "warning" | null = null;

  public messageActionUpload: string = "";

  constructor(
    private spinner: NgxSpinnerService,

    private sanitizer: DomSanitizer
  ) {}

  ngOnInit() {
    //this.previewOnly = false;
    console.log('preview', this.previewOnly)
  }

  // ====== Dropzone (cargar) ======

  async onSelect(event: any) {
    const added = event && event.addedFiles ? (event.addedFiles as File[]) : [];

    for (let i = 0; i < added.length; i++) {
      const f = added[i];

      if (f.size > 8_000_000) {
        this.statusUploadFile = "error";
        this.messageActionUpload = "Sobrepasa el tamaño máximo 8Mb";
        return;
      }

      if (f.size === 0) {
        this.statusUploadFile = "error";
        this.messageActionUpload =
          "Asegúrate que el archivo no esté comprimido (.zip, .rar).";
        return;
      }
    }

    if (added.length > 0) {
      this.files = this.files.concat(added);
      for (let i = 0; i < added.length; i++) {
        await this.createPreviewFor(added[i]);
      }
      this.statusUploadFile = "success";
      this.messageActionUpload = "Archivo cargado correctamente.";
    }
  }

  private async createPreviewFor(file: File) {
    const mime = (file.type || "").toLowerCase();
    const name = (file.name || "").toLowerCase();
    const objUrl = URL.createObjectURL(file); // para abrir/descargar

    // Imagen (data URL + SafeUrl)

    if (mime.indexOf("image/") === 0) {
      const dataUrl = await this.readAsDataURL(file);

      this.previews.push({
        file,
        fileName: file.name,
        type: "image",
        url: this.sanitizer.bypassSecurityTrustUrl(dataUrl),
        objUrl,
      });

      return;
    }

    // PDF (data URL + SafeResourceUrl)

    if (mime === "application/pdf" || name.endsWith(".pdf")) {
      const dataUrl = await this.readAsDataURL(file);

      this.previews.push({
        file,
        fileName: file.name,
        type: "pdf",
        url: this.sanitizer.bypassSecurityTrustResourceUrl(dataUrl),
        objUrl,
      });

      return;
    }

    // XML (snippet)

    if (
      mime === "text/xml" ||
      mime === "application/xml" ||
      name.endsWith(".xml")
    ) {
      const text = await this.readAsText(file);
      const snippet =
        text.length > 4000 ? text.slice(0, 4000) + "\n...\n" : text;

      this.previews.push({
        file,
        fileName: file.name,
        type: "xml",
        text: snippet,
        objUrl,
      });

      return;
    }

    // Otros
    this.previews.push({
      file,
      fileName: file.name,
      type: "other",
      objUrl,
    });
  }

  // ====== Remover item de preview ======

  onRemovePreview(item: PreviewItem) {
    // si viene del dropzone, quitar de files
    if (item.file) {
      const idxFile = this.files.indexOf(item.file);
      if (idxFile > -1) this.files.splice(idxFile, 1);
    }

    // quitar de previews
    const idxPrev = this.previews.indexOf(item);
    if (idxPrev > -1) {
      const p = this.previews[idxPrev];
      if (p.objUrl) URL.revokeObjectURL(p.objUrl);
      this.previews.splice(idxPrev, 1);
    }
    this.statusUploadFile = null;
    this.messageActionUpload = "";
  }

  closeModal() {
    for (let i = 0; i < this.previews.length; i++) {
      const p = this.previews[i];
      if (p.objUrl) URL.revokeObjectURL(p.objUrl);
    }
    this.previews = [];
    this.statusUploadFile = null;
    this.messageActionUpload = "";
    this.close.emit();
    this.previewOnly = false;
    console.log('preview', this.previewOnly)
  }

  cancelUpload() {
    // Si no hay previews, no hay nada que cancelar
    if (!this.previews || this.previews.length === 0) {
      return;
    }
   
    // Quita todos los previews (revoca URLs, limpia 'files' si aplica)
    for (let i = this.previews.length - 1; i >= 0; i--) {
      const p = this.previews[i];
      this.onRemovePreview(p);
    }
   
    // Limpia también la cola de archivos del dropzone
    this.files = [];
   
    // Restablece mensajes/estados
    this.statusUploadFile = null;
    this.messageActionUpload = '';
    //console.log('preview', this.previewOnly)
    //this.previewOnly = false;
    // Ahora el modal vuelve a mostrar el dropzone (porque previews.length === 0)
  }

  // ====== Guardar (emitir archivos en base64) ======

  async saveDataFiles() {
    this.spinner.show();

    // solo si hay archivos nuevos del dropzone

    if (this.files.length > 0) {
      for (let i = 0; i < this.files.length; i++) {
        const f = this.files[i];
        this.uploads.push({
          fileName: f.name,
          fileExtension: f.type,
          image: await this.toBase64(f),
        });
      }
    }
    this.sendFiles.emit(this.uploads);
    this.previewOnly = false;
    console.log('preview', this.previewOnly)
    this.closeModal();
    this.spinner.hide();
  }

  // ====== Helpers ======

  private async toBase64(file: File) {
    const doc: any = await this.convertFile(file);
    const parts = String(doc).split(",");
    return parts.length > 1 ? parts[1] : parts[0];
  }

  private convertFile(file: File): Promise<string | ArrayBuffer | null> {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = (e) => reject(e);
    });
  }

  private readAsDataURL(file: File): Promise<string> {
    return new Promise((resolve, reject) => {
      const r = new FileReader();
      r.readAsDataURL(file);
      r.onload = () => resolve(String(r.result || ""));
      r.onerror = (e) => reject(e);
    });
  }
  private readAsText(file: File): Promise<string> {
    return new Promise((resolve, reject) => {
      const r = new FileReader();
      r.readAsText(file);
      r.onload = () => resolve(String(r.result || ""));
      r.onerror = (e) => reject(e);
    });
  }

  // ====== Vista desde archivos existentes (base64) ======

  ngOnChanges(changes: SimpleChanges) {
    if (changes["existingUploads"]) {
      this.previews = [];

      if (this.existingUploads && this.existingUploads.length) {
        for (let i = 0; i < this.existingUploads.length; i++) {
          this.createPreviewFromExisting(this.existingUploads[i]);
        }
        this.statusUploadFile = "success";
        this.messageActionUpload = "Documento listo para visualizar.";
      }
    }
  }

  private createPreviewFromExisting(u: FileData) {
    const mime =
      (u.fileExtension || "").toLowerCase() ||
      this.guessMimeFromName(u.fileName);

    // Imagen
    if (mime.indexOf("image/") === 0) {
      const dataUrl = "data:" + mime + ";base64," + u.image;
      this.previews.push({
        fileName: u.fileName,
        type: "image",
        url: this.sanitizer.bypassSecurityTrustUrl(dataUrl),
      });
      return;
    }
    // PDF
    if (mime === "application/pdf") {
      const dataUrl = "data:application/pdf;base64," + u.image;
      this.previews.push({
        fileName: u.fileName,
        type: "pdf",
        url: this.sanitizer.bypassSecurityTrustResourceUrl(dataUrl),
      });
      return;
    }

    // XML

    if (mime === "text/xml" || mime === "application/xml") {
      let text = "";

      try {
        text = atob(u.image);
      } catch {
        text = "(XML inválido o demasiado grande)";
      }
      this.previews.push({
        fileName: u.fileName,
        type: "xml",
        text,
      });

      return;
    }

    // Otros
    const blob = this.base64ToBlob(u.image, mime || "application/octet-stream");
    const objUrl = URL.createObjectURL(blob);
    this.previews.push({
      fileName: u.fileName,
      type: "other",
      objUrl,
    });
  }

  private guessMimeFromName(name: string): string {
    const lower = (name || "").toLowerCase();
    if (lower.endsWith(".pdf")) return "application/pdf";
    if (lower.endsWith(".xml")) return "application/xml";
    if (lower.endsWith(".jpg") || lower.endsWith(".jpeg")) return "image/jpeg";
    if (lower.endsWith(".png")) return "image/png";
    return "application/octet-stream";
  }

  private base64ToBlob(b64: string, mime: string): Blob {
    const bin = atob(b64);
    const len = bin.length;
    const bytes = new Uint8Array(len);
    for (let i = 0; i < len; i++) bytes[i] = bin.charCodeAt(i);
    return new Blob([bytes], { type: mime });
  }
}
